module.exports = __webpack_public_path__ + "4.3.2/img/icon_service.2cf46cdb.png";